"use client";

import React from "react";
import { FAQ_CONTENT } from "@/constants/faqs.constants";
import AccordionContainer from "@/components/layout/accordian/accordion-container";
import AccordionItem from "@/components/layout/accordian/accordion-item";

const FaqAccordion = () => {
  return (
    <AccordionContainer>
      {FAQ_CONTENT.map((faq, index) => (
        <AccordionItem header={faq.question} key={index}>
          {faq.response}
        </AccordionItem>
      ))}
    </AccordionContainer>
  );
};

export default FaqAccordion;
